import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import AuthorizedTenantElement from "@/common/components/Auth/AuthorizedTenantElement";
import { ViewVariant } from "@/common/ts/layout";
import { VehicleDto } from "@/core/api/generated/v1";

import ChargePaginatedList from "../../../Charge/ListView/ChargePaginatedList";

interface Props {
  vehicle: VehicleDto;
}

export default function ChargesTabContent({ vehicle }: Props) {
  return (
    <PageTabContent>
      <AuthorizedTenantElement tenantIdsAny={[vehicle?.tenantId, vehicle?.ownerTenantId]} withAlert>
        <ChargePaginatedList
          defaultValues={{
            vehicleId: vehicle.id!,
          }}
          displayProps={{
            viewVariant: ViewVariant.Tab,
            header: false,
            counters: false,
          }}
        />
      </AuthorizedTenantElement>
    </PageTabContent>
  );
}
